import { useEffect, useRef } from "react";

import MVT from "ol/format/MVT.js";
import VectorTileLayer from "ol/layer/VectorTile.js";
import VectorTileSource from "ol/source/VectorTile.js";

import { GetLaancAirspaceStyle, getTileserverStatuses } from "../map/mapUtil";

import { useUserAuth } from "../contexts/authContext";
import { useEnv } from "../contexts/envContext";

const useAirspaceLayer = (map, setUserMapLayers) => {
    const layerRefreshIntervalsRef = useRef([]);

    const { userProfileSettings } = useUserAuth();
    const { laancTileServerUrl } = useEnv();

    useEffect(() => {
        if (!map) return;

        initializeAirspaceLayer();

        return () => {
            layerRefreshIntervalsRef.current.forEach((interval) => {
                clearInterval(interval);
            });
        };
    }, [map]);

    const initializeAirspaceLayer = async () => {
        // initially disable this layer and store settings
        setUserMapLayers((prev) => {
            const disabledAirspaceLayers = prev.airspaces.map((airspaceLayer) => {
                return { ...airspaceLayer, visible: false, disabled: true };
            });
            return { ...prev, airspaces: disabledAirspaceLayers };
        });

        // start health check
        const statuses = await getTileserverStatuses();
        if (statuses && statuses.laanc_tileserver === true) {
            const updatedAirspaceLayers = userProfileSettings.layers.airspaces.map((airspaceLayer) => {
                return { ...airspaceLayer, visible: airspaceLayer.visible, disabled: false };
            });
            setUserMapLayers((prev) => {
                return { ...prev, surveillance_sources_list: [], airspaces: updatedAirspaceLayers };
            });
            const source = new VectorTileSource({
                format: new MVT(),
                url: `${laancTileServerUrl}/data/LAANC_AIRSPACE/{z}/{x}/{y}.pbf?time=${new Date().getTime()}`,
                minZoom: 0,
                maxZoom: 14
            });
            const layer = new VectorTileLayer({
                source: source,
                style: (feature) => GetLaancAirspaceStyle(feature, updatedAirspaceLayers),
                minZoom: 0,
                properties: { name: "LAANC_AIRSPACE", selectable: true },
                zIndex: 1
            });
            map.addLayer(layer);
        }
    };
};

export default useAirspaceLayer;
